import Api from "../apis/api";
import {jwtDecode} from "jwt-decode";

const ACCESS_TOKEN = 'accessToken';
const UPDATED_AT = 'tokenUpdatedAt' // napisat
const UPDATE_TOKEN_DELTA = 30 // napisat

export default {
    namespaced: true,
    state: {
        errors: [],
        accessToken: localStorage.getItem(ACCESS_TOKEN),
    },
    mutations: {
        setAccessToken(state, accessToken) {
            let nowDateTime = new Date();
            let nowDateTimeIso = nowDateTime.toISOString();
            localStorage.setItem(ACCESS_TOKEN, accessToken)
            localStorage.setItem(UPDATED_AT, nowDateTimeIso)
            state.accessToken = accessToken
        },
        removeAccessToken(state) {
            state.accessToken = null
            localStorage.removeItem(ACCESS_TOKEN)
        },
        setErrors(state, errors) {
            state.errors = errors
        }
    },
    actions: {
        loginUser(state, params) {
            return Api.post('auth/login', {
                'email': params.email,
                'password': params.password,
            }).then(r => {
                state.commit('setAccessToken', r.data.accessToken)
            }).catch(err => {
                console.log(err)
            })
        },
        registerUser(state, params) {
            return Api.post('auth/register', {
                'name': params.name,
                'email': params.email,
                'password': params.password,
                'password_confirmation': params.password_confirmation,
            }).then(r => {
                state.commit('setAccessToken', r.data.accessToken)
            }).catch(err => {
                this.errors = []
                this.errors.push(err.data.status)
                console.log(err.data)
            })
        },
        logout(state) {
            state.commit('removeAccessToken')
        },
        updateToken(state) {
            if (!localStorage.getItem(UPDATED_AT) || !localStorage.getItem(ACCESS_TOKEN)) {
                return
            }
            let nowDateTime = new Date();
            let lastDateTine = new Date(localStorage.getItem(UPDATED_AT))
            if ((nowDateTime.getTime() - lastDateTine.getTime()) / 1000 >= UPDATE_TOKEN_DELTA) {
                Api.post('auth/refresh')
                    .then(r => {
                        state.commit('setAccessToken', r.data.accessToken)
                    })
            }
        },
    },
    getters: {
        getUser: (state, _,) => {
            if (state.accessToken) return jwtDecode(localStorage.getItem(ACCESS_TOKEN))
            return null
        },
        isAuth(state) {
            return !!state.accessToken;
        },
        getUsername(state, getters) {
            return getters.getUser.username
        },
        getUserEmail(state, getters) {
            return getters.getUser.email
        },
        getCredits(state, getters) {
            return getters.getUser.gates
        },
        getAccessToken(state) {
            return state.accessToken
        }
    }

}
